import { FC } from 'react'
import { Text, Center, VStack } from '@chakra-ui/react'

interface ScoreProps {
  score: number
}

export const Score: FC<ScoreProps> = ({ score }) => {
  return (
    <VStack align="stretch" px={8} spacing={6}>
      <Text textAlign="center" color="#F0980A" fontSize="32px">
        Score
      </Text>
      <Center
        fontSize="48px"
        bg="white"
        h="64px"
        borderRadius="32px"
        boxShadow="1px 7px 6px rgba(255, 193, 48, 0.5)"
      >
        {score}
      </Center>
    </VStack>
  )
}
